import React from "react";
import "./Card.css";

const Card = (props) => {
  return (
    <div className="project_card">
      <div className="temporary_text">
        <img src={props.src} alt={props.src} />
      </div>
      <div className="card_content">
        <span className="card_title">{props.title}</span>
        <span className="card_subtitle">
          {props.subtitle}
        </span>
      </div>
    </div>
  );
};

export default Card;
